import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { useGeneralResultsChartsDataContext } from './useGeneralResultsChartsDataContext';

const useVitalStatisticsComparison = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    const truncate = (text, maxLength) =>
        text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    const categories = chartData.vitalStatistics.map((item) =>
        truncate(item.description, 14)
    );

    const subtitles = ['Nascidos Vivos', 'Óbitos'];

    const series = subtitles.map((item) => {
        const data = categories.map((category) => {
            const found = chartData.vitalStatistics.find(
                (counter) => truncate(counter.description, 14) === category
            );

            let value = 0;

            switch (item) {
                case 'Nascidos Vivos':
                    value = found ? found.liveBirths : 0;
                    break;
                case 'Óbitos':
                    value = found ? found.deaths : 0;
                    break;
                default:
                    value = 0;
                    break;
            }

            return Number(value);
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                toolbar: {
                    show: true
                }
            },
            grid: {
                show: false
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                    endingShape: 'rounded',
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => val.toLocaleString('pt-BR')
                }
            },
            stroke: {
                width: 2,
                colors: ['#fff']
            },
            xaxis: {
                categories: categories || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val.toLocaleString('pt-BR')}`,
                style: {
                    colors: ['#ffffff'],
                },
                offsetX: 0,
                offsetY: -20
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? val.toLocaleString('pt-BR') : '')
                }
            },
            colors: defaultColors
        }
    };

    return {
        chartConfig
    };
};

export default useVitalStatisticsComparison;
